module.exports = __webpack_public_path__ + "img/icon.a03d4657.png";